import { render, staticRenderFns } from "./addmodal.vue?vue&type=template&id=f391baaa&scoped=true&"
import script from "./addmodal.vue?vue&type=script&lang=js&"
export * from "./addmodal.vue?vue&type=script&lang=js&"
import style0 from "./addmodal.vue?vue&type=style&index=0&id=f391baaa&scoped=true&lang=css&"
import style1 from "./addmodal.vue?vue&type=style&index=1&id=f391baaa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f391baaa",
  null
  
)

export default component.exports